import ReducerRegistry from '../base/redux/ReducerRegistry';

import {
    ADD_GIF_FOR_PARTICIPANT,
    CLOSE_GIF_MODAL,
    HIDE_GIF_FOR_PARTICIPANT,
    OPEN_GIF_MODAL,
    REMOVE_GIF_FOR_PARTICIPANT,
    SET_GIF_MENU_VISIBILITY
} from './actionTypes';

const initialState = {
    gifList: new Map(),
    menuOpen: false,
    isGifModalOpen: false
};

export interface IGif {
    gifUrl?: string;
    timeoutID?: number;
}

export interface IGifsState {
    gifList: Map<string, IGif>;
    menuOpen: boolean;
    isGifModalOpen: boolean;
}

ReducerRegistry.register(
    'features/gifs',
    (state: Object = initialState, action: Object) => {
        switch (action.type) {
        case ADD_GIF_FOR_PARTICIPANT: {
            const newList = { ...state.gifList };

            newList[action.participantId] = {
                gifUrl: action.gifUrl,
                timeoutID: action.timeoutID
            };

            return {
                ...state,
                gifList: newList
            };
        }
        case REMOVE_GIF_FOR_PARTICIPANT: {
            const newList = { ...state.gifList };

            delete newList[action.participantId];

            return {
                ...state,
                gifList: newList
            };
        }
        case HIDE_GIF_FOR_PARTICIPANT: {
            const newList = state.gifList;
            const gif = state.gifList.get(action.participantId);

            newList.set(action.participantId, {
                gifUrl: gif?.gifUrl ?? '',
                timeoutID: action.timeoutID
            });

            return {
                ...state,
                gifList: newList
            };
        }
        case SET_GIF_MENU_VISIBILITY:
            return {
                ...state,
                menuOpen: action.visible
            };

        case OPEN_GIF_MODAL:
            return {
                ...state,
                isGifModalOpen: true
            };
        case CLOSE_GIF_MODAL:
            return {
                ...state,
                isGifModalOpen: false
            };
        }

        return state;
    }
);
